import { CARD_GROUP_HORIZONTAL_MARGIN, CARD_GROUP_TOP_MARGIN } from '../consts';
import { HEADER_CELL_VERTICAL_PADDING } from '../../consts';
import { ComponentMatrixGroupOwnerType, HeaderCellModel } from '../../types';
import {
  calculateRowHeaderBottomOffset,
  calculateRowHeaderTopOffset,
  isFirstChild,
  isLastChild,
} from '../../util';

const getRowHeaderMargins = (headerCell: HeaderCellModel) => {
  const level = headerCell.indexAddress.length - 1;
  const isComponentRow =
    headerCell.group.ownerType ===
    ComponentMatrixGroupOwnerType.REFERENCED_COMPONENT;

  if (level === 0) {
    return null;
  }

  const marginLeft = level * CARD_GROUP_HORIZONTAL_MARGIN;
  const marginRight = level * CARD_GROUP_HORIZONTAL_MARGIN;

  // CARD_GROUP_TOP_MARGIN gives 8px breathing room inside the parent GroupOutline.
  // No bottom margin — the GroupOutline staircase gap handles separation at the bottom.
  if (isComponentRow) {
    return {
      marginLeft,
      marginRight,
      marginTop: CARD_GROUP_TOP_MARGIN,
      marginBottom: 0,
    };
  }

  const firstChild = isFirstChild(headerCell);
  const lastChild = isLastChild(headerCell);

  const marginTop = firstChild
    ? calculateRowHeaderTopOffset(headerCell.indexAddress)
    : HEADER_CELL_VERTICAL_PADDING;

  const marginBottom =
    HEADER_CELL_VERTICAL_PADDING +
    (lastChild ? calculateRowHeaderBottomOffset(level) : 0);

  return { marginLeft, marginRight, marginTop, marginBottom };
};

export { getRowHeaderMargins };
